var meta = { showLeftMenu: false, headIndex: 1 };
export var router = [{
	path: '/ctDataQuery',
	meta: meta,
	name: 'ctDataQuery',
	component: resolve => require(["./ctDataQueryFeature.vue"], resolve)
},
{
	path: '/ctQuery',
	meta: meta,
	name: 'ctQuery',
	component: resolve => require(["./ctQuery.vue"], resolve)
},
{
	path: '/dataSourceQuery',
	meta: meta,
	name: 'dataSourceQuery',
	component: resolve => require(["./dataSourceQuery.vue"], resolve)
},
{
	path: '/configStatistics',
	meta: meta,
	name: 'configStatistics',
	component: resolve => require(["./configStatistics.vue"], resolve)
},
{
	path: '/dataSourceQueryDetail',
	meta: meta,
	name: 'dataSourceQueryDetail',
	component: resolve => require(["./dataSourceQueryDetail.vue"], resolve)
},
{
	path: '/itDataQuery',
	meta: meta,
	name: 'itDataQuery',
	component: resolve => require(["./itDataQuery.vue"], resolve)
},
{
	path: '/itQuery',
	meta: meta,
	name: 'itQuery',
	component: resolve => require(["./itQuery.vue"], resolve)
},
{
	path: '/label',
	meta: meta,
	name: 'label',
	component: resolve => require(["./labelSelect.vue"], resolve)
},
{
	path: '/diagFileDownload',
	meta: meta,
	name: 'diagFileDownload',
	component: resolve => require(["./diagFileDownload.vue"], resolve)
},
{
	path: '/topoDisplay',
	meta: meta,
	name: 'topoDisplay',
	component: resolve => require(["./topoDisplay.vue"], resolve)
}
]


// WEBPACK FOOTER //
// ./src/views/dataQuery/router.js